import pulseEvent from './global/pulseEvent';

const reportEventTime = (
  timeStamp = new Date().getTime(),
  eventCategory,
  eventAction,
  designation,
  empType,
  team,
  loggedInEmpCode,
  custId,
  screenname,
) => {
  try {
    const duration = new Date().getTime() - timeStamp;
    const totalSeconds = duration / 1000;
    const logTime = `${totalSeconds}`;

    pulseEvent(
      eventCategory,
      eventAction,
      designation,
      empType,
      team,
      loggedInEmpCode,
      screenname,
      undefined,
      logTime,
      undefined,
    );
  } catch (e) {
    console.log(e);
  }
};
export default { reportEventTime };
